import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { setAppBusy } from 'store/actions/system';
import { addAddress, getAccount } from 'gateways/Api';
import { resetSubscriptionsList } from 'store/actions/subscription';
import { setAccount } from 'store/actions/account';
import useMessages from 'hooks/useMessages';
import { SAVE_ADDRESS_CONFIRMATION, SAVE_ADDRESS_PACK_CONFIRMATION } from 'helpers/copyHelper';

export default () => {
  const { genericInfoMessage, genericFailureMessage } = useMessages();
  const multipleSubs = useSelector((state) => state.subscriptions.length > 1);
  const dispatch = useDispatch();

  return ({
    address,
    subscription,
    pack,
    onSuccess,
    onFailure = () => genericFailureMessage('Oops, something went wrong. Please try adding a new address again.'),
    makePrimary = false,
    applyToAll = false,
  }) => {
    dispatch(setAppBusy(true));
    const applicablePacks = applyToAll
      ? subscription.packs
        .filter(
          (p) => moment(p.delivery_date).isAfter()
                  && ['Pending'].includes(p.status),
        )
        .map((p) => p.id)
      : (pack && [pack.id]);

    const switchToPrimary = makePrimary && !address.is_default;

    addAddress(
      makePrimary ? { ...address, is_default: true } : address,
      subscription.id,
      applicablePacks,
      switchToPrimary,
    )
      .then(() => {
        if ((applyToAll || makePrimary) && !pack) {
          genericInfoMessage(SAVE_ADDRESS_CONFIRMATION(applyToAll, makePrimary, multipleSubs));
        } else if (pack) {
          if (applyToAll) {
            genericInfoMessage(SAVE_ADDRESS_CONFIRMATION(applyToAll, makePrimary, multipleSubs));
          } else {
            genericInfoMessage(SAVE_ADDRESS_PACK_CONFIRMATION(moment(pack.deliveryDate).format('MMMM YYYY'), makePrimary));
          }
        }
      })
      .then(() => getAccount())
      .then((updatedAccount) => dispatch(setAccount(updatedAccount)))
      .then(() => {
        if (applicablePacks && applicablePacks.length) {
          dispatch(resetSubscriptionsList());
        }
      })
      .then(onSuccess)
      .catch(() => onFailure())
      .finally(() => dispatch(setAppBusy(false)));
  };
};
